export default {
    auth_details_error_title: "We could not load your session",
    auth_details_error_message: "The service is not reachable right now. Please try again in a few seconds.",
    auth_details_error_retry: "Retry",
    auth_details_error_reload: "Reload page",
};
